(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-chair-pack-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-chair-clearance')) {
  customElements.define('cc-chair-clearance', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.info = this.closest('.product__info-container');
      this.money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'}).format(cents/100);
      this.querySelectorAll('input[type=radio]').forEach(input => input.addEventListener('change', () => this.refresh()));
      this.querySelector('[data-add]').addEventListener('click', () => this.add());
      this.refresh();
    }
    build(kind, count) {
      const holder = this.querySelector('[data-'+kind+'-colors]');
      if (holder.children.length === count) return;
      const previous = [...holder.querySelectorAll('select')].map(s=>s.value);
      holder.replaceChildren();
      const variants = this.config[kind === 'chair' ? 'chairs' : 'blankets'].filter(v=>v.available);
      const defaultVariant = kind === 'chair' ? [...variants].sort((a,b)=>b.stock-a.stock)[0] : variants[0];
      for(let i=0;i<count;i++) {
        const label = document.createElement('label'); label.className='cc-chair-pack__color';
        label.textContent = this.config[kind+'Label']+' '+(i+1);
        const select = document.createElement('select'); select.setAttribute('aria-label',label.textContent);
        variants.forEach(v=>{const option=document.createElement('option');option.value=v.id;option.textContent=v.title;select.append(option)});
        select.value=previous[i] || defaultVariant?.id || '';
        select.addEventListener('change',()=>this.refresh());label.append(select);holder.append(label);
      }
    }
    selected(kind) {
      const variants=this.config[kind==='chair'?'chairs':'blankets'];
      return [...this.querySelectorAll('[data-'+kind+'-colors] select')].map(s=>variants.find(v=>String(v.id)===s.value)).filter(Boolean);
    }
    refresh() {
      this.count=Number(this.querySelector('input:checked').value);
      const active=this.count>1;
      this.info?.classList.toggle('cc-chair-pack-mode',active);
      this.querySelector('[data-choices]').hidden=!active;
      this.querySelector('[data-status]').textContent='';
      if(!active)return;
      this.build('chair',this.count);this.build('blanket',this.count===4?2:1);
      const chairs=this.selected('chair'), blankets=this.selected('blanket');
      const original=chairs.reduce((s,v)=>s+Math.max(v.price,v.compare),0)+blankets.reduce((s,v)=>s+v.price,0);
      const total=chairs.reduce((s,v)=>s+v.price,0)+(this.count===2?Math.max(0,(blankets[0]?.price||0)-2000):0);
      this.querySelector('[data-original]').textContent=this.money(original);
      this.querySelector('[data-total]').textContent=this.money(total);
      this.querySelector('[data-savings]').textContent=this.config.save+' '+this.money(original-total);
      this.querySelector('[data-add]').disabled=chairs.length!==this.count || blankets.length!==(this.count===4?2:1);
      if(this.querySelector('[data-add]').disabled)this.querySelector('[data-status]').textContent=this.config.unavailable;
    }
    async add() {
      const button=this.querySelector('[data-add]'),status=this.querySelector('[data-status]');
      button.disabled=true;button.textContent=this.config.adding;status.textContent='';
      try {
        const counts=new Map();
        [...this.selected('chair'),...this.selected('blanket')].forEach(v=>counts.set(v.id,(counts.get(v.id)||0)+1));
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[...counts].map(([id,quantity])=>({id,quantity})),sections:'cart-drawer,cart-icon-bubble',sections_url:location.pathname})});
        const result=await response.json();if(!response.ok)throw new Error(result.description||this.config.error);
        const drawer=document.querySelector('cart-drawer');
        if(drawer?.renderContents && result.sections?.['cart-drawer']) {drawer.classList.remove('is-empty');drawer.setActiveElement?.(button);drawer.renderContents(result)}
        else {location.href=(window.Shopify?.routes?.root||'/')+'cart'}
      } catch(error) {status.textContent=error.message||this.config.error}
      finally {button.disabled=false;button.textContent=this.config.add}
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-towel-pack-selector"] && !Shopify.designMode) return;
  try {
    (() => {
      const roots = document.querySelectorAll('[data-cc-towel-pack]');

      roots.forEach((root) => {
        if (root.dataset.initialized === 'true') return;
        root.dataset.initialized = 'true';

        const variants = JSON.parse(root.querySelector('[data-cc-pack-variants]').textContent);
        const availableVariants = variants.filter((variant) => variant.available);
        const radios = Array.from(root.querySelectorAll('input[name="cc-towel-pack-size"]'));
        const colorsWrap = root.querySelector('[data-cc-pack-colors]');
        const colorGrid = root.querySelector('[data-cc-pack-color-grid]');
        const summary = root.querySelector('[data-cc-pack-summary]');
        const total = root.querySelector('[data-cc-pack-total]');
        const each = root.querySelector('[data-cc-pack-each]');
        const addButton = root.querySelector('[data-cc-pack-add]');
        const status = root.querySelector('[data-cc-pack-status]');
        const infoContainer = root.closest('.product__info-container');
        const currency = window.Shopify?.currency?.active || 'USD';

        const formatMoney = (cents) => new Intl.NumberFormat(
          document.documentElement.lang || 'en-US',
          { style: 'currency', currency }
        ).format(Number(cents || 0) / 100);

        const mainForm = () => {
          if (!infoContainer) return null;
          return infoContainer.querySelector('form[action*="/cart/add"]');
        };

        const selectedMainVariantId = () => mainForm()?.querySelector('input[name="id"]')?.value;

        const buildColorSelectors = (count) => {
          const currentValues = Array.from(colorGrid.querySelectorAll('select')).map((select) => select.value);
          const mainId = selectedMainVariantId();
          colorGrid.innerHTML = '';

          for (let index = 0; index < count; index += 1) {
            const label = document.createElement('label');
            label.className = 'cc-towel-pack__color';
            const colorLabel = root.dataset.colorLabel.replace('__COUNT__', index + 1);
            label.textContent = colorLabel;

            const select = document.createElement('select');
            select.setAttribute('aria-label', colorLabel);
            select.dataset.ccPackColor = '';

            availableVariants.forEach((variant) => {
              const option = document.createElement('option');
              option.value = variant.id;
              option.textContent = variant.title;
              option.dataset.price = variant.price;
              select.appendChild(option);
            });

            select.value = currentValues[index] || mainId || availableVariants[0]?.id;
            select.addEventListener('change', refresh);
            label.appendChild(select);
            colorGrid.appendChild(label);
          }
        };

        const selectedCount = () => Number(radios.find((radio) => radio.checked)?.value || 1);

        const refresh = () => {
          const count = selectedCount();
          const packMode = count > 1;

          if (packMode && colorGrid.querySelectorAll('select').length !== count) {
            buildColorSelectors(count);
          }

          colorsWrap.hidden = !packMode;
          summary.hidden = !packMode;
          addButton.hidden = !packMode;
          infoContainer?.classList.toggle('cc-towel-pack-mode', packMode);

          const mainVariant = availableVariants.find(v => String(v.id) === String(selectedMainVariantId())) || availableVariants[0];
          [3,4].forEach(tierCount => {
            const chosen = Array.from(colorGrid.querySelectorAll('select')).map(select => availableVariants.find(v => String(v.id) === String(select.value))).filter(Boolean);
            const tierVariants = count === tierCount && chosen.length === tierCount ? chosen : Array(tierCount).fill(mainVariant).filter(Boolean);
            const full = tierVariants.reduce((sum,v) => sum+Number(v.price),0);
            const saving = tierVariants.length ? Math.min(...tierVariants.map(v=>Number(v.price))) : 0;
            const price = root.querySelector('[data-cc-tier-price="'+tierCount+'"]');
            price.replaceChildren();
            const strike = document.createElement('s');strike.textContent=formatMoney(full);price.append(strike,document.createTextNode(formatMoney(full-saving)));
            root.querySelector('[data-cc-tier-saving="'+tierCount+'"]').textContent = root.dataset.saveLabel+' '+(full ? Math.round(saving/full*100) : 0)+'%';
          });

          if (!packMode) {
            status.textContent = '';
            return;
          }

          const selectedVariants = Array.from(colorGrid.querySelectorAll('select')).map((select) => (
            availableVariants.find((variant) => String(variant.id) === String(select.value))
          )).filter(Boolean);

          const subtotal = selectedVariants.reduce((sum, variant) => sum + Number(variant.price), 0);
          const discount = count >= 3 && selectedVariants.length === count ? Math.min(...selectedVariants.map(variant => Number(variant.price))) : 0;
          const estimated = Math.max(0, subtotal - discount);
          const perTowel = Math.round(estimated / count);
          const original = subtotal;
          const saved = original - estimated;
          const originalEl = root.querySelector('[data-cc-pack-original]');
          originalEl.hidden = original <= estimated;
          originalEl.textContent = formatMoney(original);

          total.textContent = formatMoney(estimated);
          each.textContent = `${formatMoney(perTowel)} ${root.dataset.eachLabel}` + (saved > 0 ? ` · ${root.dataset.saveLabel} ${formatMoney(saved)} (${Math.round(saved / original * 100)}%)` : '');
          addButton.textContent = root.dataset.addLabel.replace('__COUNT__', count);
        };

        radios.forEach((radio) => radio.addEventListener('change', refresh));

        infoContainer?.addEventListener('change', (event) => {
          if (!event.target.closest('form[action*="/cart/add"]')) return;
          const firstSelect = colorGrid.querySelector('select');
          const mainId = selectedMainVariantId();
          if (firstSelect && mainId) firstSelect.value = mainId;
          refresh();
        });

        document.addEventListener('variant:change', () => {
          window.setTimeout(() => {
            const firstSelect = colorGrid.querySelector('select');
            const mainId = selectedMainVariantId();
            if (firstSelect && mainId) firstSelect.value = mainId;
            refresh();
          }, 0);
        });

        addButton.addEventListener('click', async () => {
          const selects = Array.from(colorGrid.querySelectorAll('select'));
          const quantities = new Map();

          selects.forEach((select) => {
            quantities.set(select.value, (quantities.get(select.value) || 0) + 1);
          });

          const items = Array.from(quantities, ([id, quantity]) => ({
            id: Number(id),
            quantity
          }));

          addButton.disabled = true;
          status.textContent = '';

          try {
            const drawer = document.querySelector('cart-drawer');
            const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items,
                sections: 'cart-drawer,cart-icon-bubble',
                sections_url: window.location.pathname || '/'
              })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || root.dataset.errorLabel);
            if (!drawer?.renderContents || !result.sections) {
              throw new Error('Your towels were added, but the cart drawer could not open. Please use the cart icon.');
            }

            status.textContent = root.dataset.addedLabel;
            addButton.disabled = false;
            drawer.setActiveElement?.(addButton);
            drawer.renderContents(result);
          } catch (error) {
            status.textContent = error.message || root.dataset.errorLabel;
            addButton.disabled = false;
          }
        });

        refresh();
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
